import type { DriveStep } from 'driver.js'

export const billingTour: Array<DriveStep> = [
  {
    element: '#current-plan-card',
    popover: {
      title: 'Your Current Plan',
      description:
        'View your active subscription tier, included features, and current usage limits.',
      side: 'bottom',
    },
  },
  {
    element: '#pricing-tiers',
    popover: {
      title: 'Available Plans',
      description:
        'Compare pricing tiers to find the right balance of features, rate limits, and cost for your needs.',
      side: 'top',
    },
  },
  {
    element: '#upgrade-plan-btn',
    popover: {
      title: 'Upgrade Anytime',
      description:
        'Unlock premium models, higher rate limits, and priority support. Upgrades take effect immediately.',
      side: 'left',
    },
  },
  {
    element: '#payment-methods',
    popover: {
      title: 'Payment Methods',
      description:
        'Manage credit cards, set up automatic billing, and view payment history.',
      side: 'right',
    },
  },
  {
    element: '#usage-limits',
    popover: {
      title: 'Monitor Your Limits',
      description:
        'Track your quota usage to avoid service interruptions. Set up alerts to notify you when approaching limits.',
      side: 'top',
    },
  },
]
